<template>
  <div class="bk bk-touch-action-bar bk-control">
    <button
      class="bk-button"
      :class="danger ? 'bk-is-danger' : 'bk-is-primary'"
      @click.stop.prevent.capture="$emit('click')"
    >
      {{ label }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  danger: { type: Boolean, required: false }
});
defineEmits(["click"]);
</script>

<script>
export default {
  name: "TouchActionBar"
};
</script>
